export const alloysPartnersShopifyAppGroupIdBridgesBridgeIdCatalogItemErrorCount =
  "/alloys/partners/shopify/:app_group_id/bridges/:bridge_id/catalog/item_error_count";
